<template>
  <div>
    <el-drawer
      title="Reportes de AutoMV"
      :visible.sync="showDrawerAutoMvReport"
      :before-close="beforeClose"
      size="75%"
      :modal="false"
    >
      <el-card class="card">
        <div>
          <el-row>
            <rabbey-table3
              ref="autoMVDetails"
              :stripe="true"
              :columns="Columns"
              :actions="Actions"
              :data="DataDetails"
              @rtable-push-action="handlePushAction"
              v-loading="loading"
            />
          </el-row>
        </div>
      </el-card>
    </el-drawer>
    <ViewAutoMvForm
      :openAutoMVView="openAutoMVView"
      :AutoMVFormModel="DataAutoMVFormModel"
      :TasktableDataOperacional="TasktableDataOperacional"
      :totalTaksClosedOnTimeOperacional="
        totalTaksClosedOnTimeOperacional.length
      "
      :totalTaksClosedOnLateOperacional="
        totalTaksClosedOnLateOperacional.length
      "
      :totalTaksOpenOnTimeOperacional="totalTaksOpenOnTimeOperacional.length"
      :totalTaksOpenOnLateOperacional="totalTaksOpenOnLateOperacional.length"
      :taksOpenOnTimeOperacional="taksOpenOnTimeOperacional.length"
      :taskOpenOnLateOnWeekOperacional="taskOpenOnLateOnWeekOperacional.length"
      :taskCloseOnLateOnWeekOperacional="
        taskCloseOnLateOnWeekOperacional.length
      "
      :taksClosedOnTimeOperacional="taksClosedOnTimeOperacional.length"
      :percetangeWeekOperacional="percetangeWeekOperacional"
      :percetangeTotalOperacionall="percetangeTotalOperacional"
      :TasktableDataEstrategico="TasktableDataEstrategico"
      :totalTaksClosedOnTimeEstrategico="
        totalTaksClosedOnTimeEstrategico.length
      "
      :totalTaksClosedOnLateEstrategicoo="
        totalTaksClosedOnLateEstrategico.length
      "
      :totalTaksOpenOnTimeEstrategico="totalTaksOpenOnTimeEstrategico.length"
      :totalTaksOpenOnLateEstrategico="totalTaksOpenOnLateEstrategico.length"
      :taskOpenOnLateOnWeekEstrategico="taskOpenOnLateOnWeekEstrategico.length"
      :taksClosedOnTimeEstrategico="taksClosedOnTimeEstrategico.length"
      :taksOpenOnTimeEstrategico="taksOpenOnTimeEstrategico.length"
      :taskCloseOnLateOnWeekEstrategico="
        taskCloseOnLateOnWeekEstrategico.length
      "
      :percetangeWeekEstrategico="percetangeWeekEstrategico"
      :percetangeTotalEstrategico="percetangeTotalEstrategico"
      :isSupervisor="isSupervisor"
      :createdAt="createdAtt"
      :loadingFormItem="loading"
      @onClose="closeAutoMVView"
    />
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
import {
  AutoMVDetailcolumns,
  AutoMVDetailAction
} from "@/views/apps/cmi/AutoMvs/colums/AutoMVDetailColums.js";
import ViewAutoMvForm from "@/views/apps/cmi/AutoMvs/ViewForm/ViewAutoMvForm.vue";

export default {
  name: "AutoMvReport",
  components: {
    ViewAutoMvForm
  },
  data() {
    return {
      Columns: AutoMVDetailcolumns,
      Actions: AutoMVDetailAction,
      loading: false,
      DataDetails: [],
      detalleEmpresaNombre: "",
      openAutoMVView: false,
      isSupervisor: false,
      DataAutoMVFormModel: {},
      TasktableData: [],
      TasktableDataOperacional: [],
      TasktableDataEstrategico: [],
      totalTaksClosedOnTime: [],
      totalTaksClosedOnTimeOperacional: [],
      totalTaksClosedOnTimeEstrategico: [],
      totalTaksClosedOnLate: [],
      totalTaksClosedOnLateOperacional: [],
      totalTaksClosedOnLateEstrategico: [],
      totalTaksOpenOnTime: [],
      totalTaksOpenOnTimeOperacional: [],
      totalTaksOpenOnTimeEstrategico: [],
      totalTaksOpenOnLate: [],
      totalTaksOpenOnLateOperacional: [],
      percetangeWeekOperacional: 0,
      percetangeTotalOperacional: 0,
      totalTaksOpenOnLateEstrategico: [],

      taskCloseOnLateOnWeek: [],
      taskCloseOnLateOnWeekOperacional: [],
      taskCloseOnLateOnWeekEstrategico: [],
      taksClosedOnTimeOperacional: [],
      taksOpenOnTimeOperacional: [],
      taskOpenOnLateOnWeek: [],
      taskOpenOnLateOnWeekOperacional: [],
      taksOpenOnTimeEstrategico: [],
      taskOpenOnLateOnWeekEstrategico: [],
      taksClosedOnTimeEstrategico: [],
      percetangeWeekEstrategico: 0,
      percetangeTotalEstrategico: 0,
      createdAtt: ""
    };
  },
  props: {
    showDrawerAutoMvReport: {
      type: Boolean,
      default: false
    },
    UserId: {
      type: Number,
      default: 0
    },
    Month: {
      type: Number,
      default: 0
    },
    Year: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // this.GetAutoMVsByMonth();
  },
  methods: {
    formatMonto,
    async GetAutoMVsByMonth() {
      // console.log("GetAutoMVsByMonth");
      this.loading = true;
      this.$http
        .get(
          `/api/CMI/AutoMVs/GetAutoMVsByOwner?year=${this.Year}&month=${this.Month}&userId=${this.UserId}&currentUser=${this.currentUser.EmployeeId}`
        )
        .then((resp) => {
          // console.log("GetAutoMVsByOwner resp: ", resp);
          this.DataDetails = resp.data;
          this.loading = false;
        })
        .catch((err) => {
          console.error("Error en GetAutoMVsByOwner: ", err);
        });
    },
    async handlePushAction(option) {
      let today = new Date();
      let validateToday = today.getDay();
      // Obtener la fecha de inicio y fin de la semana actual
      const fechaActual = new Date();
      const primerDiaSemanaActual = new Date(
        fechaActual.setDate(fechaActual.getDate() - fechaActual.getDay())
      );

      const ultimoDiaSemanaActual = new Date(
        fechaActual.setDate(primerDiaSemanaActual.getDate() + 6)
      );

      const ultimoDiaSemanaPasada = new Date(
        fechaActual.setDate(primerDiaSemanaActual.getDate() - 1)
      );

      const primerDiaSemanaPasada = new Date(
        fechaActual.setDate(ultimoDiaSemanaPasada.getDate() - 6)
      );

      if (option.command == "view-auto-mv") {
        this.loading = true;
        this.$http
          .get(`/api/CMI/AutoMVs/GetAutoMVsById?id=${option.row.IdAutoMV}`)
          .then((resp) => {
            this.DataAutoMVFormModel = resp.data;
            const createdAt = new Date(resp.data.CreatedAt);
            this.createdAtt = resp.data.CreatedAt;

            //LOGICA PARA TAB OPERACIONAL
            this.TasktableDataOperacional = resp.data.task.filter((data) => {
              return data.TypeStrategic === 1 && data.StausTasks != 3;
            });

            //Total de datareas cerrada a tiempo
            this.totalTaksClosedOnTimeOperacional = resp.data.task.filter(
              (data) => data.StausTasks == 1 && data.TypeStrategic === 1
            );

            //Total de datareas cerrada a tiempo en la semana
            this.taksClosedOnTimeOperacional = resp.data.task.filter((data) => {
              const fechaCierre = new Date(data.ClosedDate);

              var diferenciaMilisegundos = Math.abs(
                createdAt.getTime() - fechaCierre.getTime()
              );

              // Calcular la diferencia en días
              var diferenciaDias = Math.floor(
                diferenciaMilisegundos / (1000 * 60 * 60 * 24)
              );

              return (
                diferenciaDias <= 7 &&
                data.StausTasks == 1 &&
                data.TypeStrategic === 1
              );
            });

            //Total de tareas cerrada retrasadas
            this.totalTaksClosedOnLateOperacional = resp.data.task.filter(
              (data) => data.StausTasks == 2 && data.TypeStrategic === 1
            );

            //Total de tareas cerrada retrasadas de la semana
            this.taskCloseOnLateOnWeekOperacional = resp.data.task.filter(
              (evento) => {
                // const fechaLimite = new Date(evento.LimiteDate);
                const fechaCierre = new Date(evento.ClosedDate);

                var diferenciaMilisegundos = Math.abs(
                  createdAt.getTime() - fechaCierre.getTime()
                );

                // Calcular la diferencia en días
                var diferenciaDias = Math.floor(
                  diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                );

                return (
                  diferenciaDias <= 7 &&
                  evento.StausTasks == 2 &&
                  evento.TypeStrategic === 1
                );
              }
            );

            this.totalTaksOpenOnTimeOperacional = resp.data.task.filter(
              (data) => data.StausTasks == 3 && data.TypeStrategic === 1
            );

            this.taksOpenOnTimeOperacional = resp.data.task.filter((evento) => {
              const fechaLimite = new Date(evento.LimiteDate);

              var diferenciaMilisegundos = Math.abs(
                createdAt.getTime() - fechaLimite.getTime()
              );

              // Calcular la diferencia en días
              var diferenciaDias = Math.floor(
                diferenciaMilisegundos / (1000 * 60 * 60 * 24)
              );

              return (
                diferenciaDias <= 7 &&
                fechaLimite >= createdAt &&
                evento.StausTasks == 3 &&
                evento.TypeStrategic === 1
              );
            });

            this.totalTaksOpenOnLateOperacional = resp.data.task.filter(
              (data) => data.StausTasks == 4 && data.TypeStrategic === 1
            );

            this.taskOpenOnLateOnWeekOperacional = resp.data.task.filter(
              (evento) => {
                const fechaLimite = new Date(evento.LimiteDate);

                var diferenciaMilisegundos = Math.abs(
                  createdAt.getTime() - fechaLimite.getTime()
                );

                // Calcular la diferencia en días
                var diferenciaDias = Math.floor(
                  diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                );

                return (
                  diferenciaDias <= 7 &&
                  fechaLimite <= createdAt &&
                  evento.StausTasks == 4 &&
                  evento.TypeStrategic === 1
                );
              }
            );

            //LOGICA PARA OPERACIONAL
            this.percetangeWeekOperacional =
              (this.taksClosedOnTimeOperacional.length /
                (this.taksClosedOnTimeOperacional.length +
                  this.taskOpenOnLateOnWeekOperacional.length +
                  this.taskCloseOnLateOnWeekOperacional.length)) *
              100;

            this.percetangeWeekOperacional = Math.round(
              this.percetangeWeekOperacional
            );

            this.percetangeTotalOperacional =
              (this.totalTaksClosedOnTimeOperacional
                .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                (this.totalTaksOpenOnLateOperacional.length +
                  this.totalTaksClosedOnTimeOperacional.length +
                  this.totalTaksClosedOnLateOperacional.length)) *
              100;
            this.percetangeTotalOperacional = Math.round(
              this.percetangeTotalOperacional
            );

            this.TasktableDataEstrategico = resp.data.task.filter((data) => {
              return data.TypeStrategic === 2 && data.StausTasks != 3;
            });

            // Total de tareas completadas estrategico
            this.totalTaksClosedOnTimeEstrategico = resp.data.task.filter(
              (data) => data.StausTasks == 1 && data.TypeStrategic === 2
            );

            this.taksClosedOnTimeEstrategico = resp.data.task.filter(
              (evento) => {
                const fechaCierre = new Date(evento.ClosedDate);

                var diferenciaMilisegundos = Math.abs(
                  createdAt.getTime() - fechaCierre.getTime()
                );

                // Calcular la diferencia en días
                var diferenciaDias = Math.floor(
                  diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                );

                return (
                  diferenciaDias <= 7 &&
                  evento.StausTasks == 1 &&
                  evento.TypeStrategic === 2
                );
              }
            );

            // this.totalTaksClosedOnTimeEstrategico.push(d);
            this.totalTaksClosedOnLateEstrategico = resp.data.task.filter(
              (data) => data.StausTasks == 2 && data.TypeStrategic === 2
            );

            this.taskCloseOnLateOnWeekEstrategico = resp.data.task.filter(
              (evento) => {
                const fechaCierre = new Date(evento.ClosedDate);

                var diferenciaMilisegundos = Math.abs(
                  createdAt.getTime() - fechaCierre.getTime()
                );

                // Calcular la diferencia en días
                var diferenciaDias = Math.floor(
                  diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                );

                return (
                  diferenciaDias <= 7 &&
                  evento.StausTasks == 2 &&
                  evento.TypeStrategic === 2
                );
              }
            );

            this.totalTaksOpenOnTimeEstrategico = resp.data.task.filter(
              (data) => data.StausTasks == 3 && data.TypeStrategic === 2
            );

            this.taksOpenOnTimeEstrategico = resp.data.task.filter((evento) => {
              const fechaLimite = new Date(evento.LimiteDate);

              var diferenciaMilisegundos = Math.abs(
                createdAt.getTime() - fechaLimite.getTime()
              );

              // Calcular la diferencia en días
              var diferenciaDias = Math.floor(
                diferenciaMilisegundos / (1000 * 60 * 60 * 24)
              );

              return (
                diferenciaDias <= 7 &&
                fechaLimite >= createdAt &&
                evento.StausTasks == 3 &&
                evento.TypeStrategic === 2
              );
            });
            this.totalTaksOpenOnLateEstrategico = resp.data.task.filter(
              (data) => data.StausTasks == 4 && data.TypeStrategic === 2
            );

            this.taskOpenOnLateOnWeekEstrategico = resp.data.task.filter(
              (evento) => {
                const fechaLimite = new Date(evento.LimiteDate);

                var diferenciaMilisegundos = Math.abs(
                  createdAt.getTime() - fechaLimite.getTime()
                );

                // Calcular la diferencia en días
                var diferenciaDias = Math.floor(
                  diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                );

                return (
                  diferenciaDias <= 7 &&
                  fechaLimite <= createdAt &&
                  evento.StausTasks == 4 &&
                  evento.TypeStrategic === 2
                );
              }
            );

            //LOGICA PAR OPERACIONAL
            this.percetangeWeekEstrategico =
              (this.taksClosedOnTimeEstrategico.length /
                (this.taksClosedOnTimeEstrategico.length +
                  this.taskCloseOnLateOnWeekEstrategico.length +
                  this.taskOpenOnLateOnWeekEstrategico.length)) *
              100;
            this.percetangeWeekEstrategico = Math.round(
              this.percetangeWeekEstrategico
            );

            this.percetangeTotalEstrategico =
              (this.totalTaksClosedOnTimeEstrategico
                .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                (this.totalTaksOpenOnLateEstrategico.length +
                  this.totalTaksClosedOnTimeEstrategico.length +
                  this.totalTaksClosedOnLateEstrategico.length)) *
              100;

            this.percetangeTotalEstrategico = Math.round(
              this.percetangeTotalEstrategico
            );
          })
          .catch((err) => {
            console.error("Error en GetAutoMVsByOwner: ", err);
          });

        this.loading = false;
        this.openAutoMVView = true;
      } else if (option.command == "edit-auto-mv") {
        this.loading = true;
        this.$http
          .get(`/api/CMI/AutoMVs/GetAutoMVsById?id=${option.row.IdAutoMV}`)
          .then((resp) => {
            this.DataAutoMVFormModel = resp.data;

            resp.data.task.forEach((d) => {
              this.TasktableDataOperacional = resp.data.task.filter((data) => {
                return data.TypeStrategic === 1;
              });

              if (d.StausTasks == 1 && d.TypeStrategic === 1) {
                this.totalTaksClosedOnTimeOperacional.push(d);
              } else if (d.StausTasks == 2 && d.TypeStrategic === 1) {
                this.totalTaksClosedOnLateOperacional.push(d);

                this.taskCloseOnLateOnWeekOperacional = resp.data.task.filter(
                  (evento) => {
                    const fechaCierre = new Date(evento.LimiteDate);

                    if (
                      validateToday == 5 /*viernes*/ ||
                      validateToday == 6 /*Sabado*/
                    ) {
                      return (
                        fechaCierre >= primerDiaSemanaActual &&
                        fechaCierre <= ultimoDiaSemanaActual &&
                        evento.StausTasks == 2
                      );
                    }
                    return (
                      fechaCierre >= primerDiaSemanaPasada &&
                      fechaCierre <= ultimoDiaSemanaPasada &&
                      evento.StausTasks == 2
                    );
                  }
                );
              } else if (d.StausTasks == 3 && d.TypeStrategic === 1) {
                this.totalTaksOpenOnTimeOperacional.push(d);
              } else if (d.StausTasks == 4 && d.TypeStrategic === 1) {
                this.totalTaksOpenOnLateOperacional.push(d);

                this.taskOpenOnLateOnWeekOperacional = resp.data.task.filter(
                  (evento) => {
                    // console.log("aaaa",primerDiaSemana, ultimoDiaSemana)
                    // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                    const fechaCierre = new Date(evento.LimiteDate);

                    if (
                      validateToday == 5 /*viernes*/ ||
                      validateToday == 6 /*Sabado*/
                    ) {
                      return (
                        fechaCierre >= primerDiaSemanaActual &&
                        fechaCierre <= ultimoDiaSemanaActual &&
                        evento.StausTasks == 4
                      );
                    }
                    return (
                      fechaCierre >= primerDiaSemanaPasada &&
                      fechaCierre <= ultimoDiaSemanaPasada &&
                      evento.StausTasks == 4
                    );
                  }
                );
              }

              this.percetangeWeekOperacional =
                (this.totalTaksClosedOnTimeOperacional.length /
                  (this.totalTaksClosedOnTimeOperacional.length +
                    this.taskOpenOnLateOnWeekOperacional.length +
                    this.taskCloseOnLateOnWeekOperacional.length)) *
                100;
              this.percetangeWeekOperacional = Math.round(
                this.percetangeWeekOperacional
              );

              this.percetangeTotalOperacional =
                (this.totalTaksClosedOnTimeOperacional
                  .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                  (this.totalTaksOpenOnLateOperacional.length +
                    this.totalTaksClosedOnTimeOperacional.length +
                    this.totalTaksClosedOnLateOperacional.length)) *
                100;
              this.percetangeTotalOperacional = Math.round(
                this.percetangeTotalOperacional
              );

              //LOGICA PARA ESTRATEGICO

              this.TasktableDataEstrategico = resp.data.task.filter((data) => {
                return data.TypeStrategic === 2;
              });

              if (d.StausTasks == 1 && d.TypeStrategic === 2) {
                this.totalTaksClosedOnTimeEstrategico.push(d);
              } else if (d.StausTasks == 2 && d.TypeStrategic === 2) {
                this.totalTaksClosedOnLateEstrategico.push(d);

                this.taskCloseOnLateOnWeekEstrategico = resp.data.task.filter(
                  (evento) => {
                    // console.log("aaaa", evento);
                    // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                    const fechaCierre = new Date(evento.LimiteDate);

                    if (
                      validateToday == 5 /*viernes*/ ||
                      validateToday == 6 /*Sabado*/
                    ) {
                      return (
                        fechaCierre >= primerDiaSemanaActual &&
                        fechaCierre <= ultimoDiaSemanaActual &&
                        evento.StausTasks == 2
                      );
                    }
                    return (
                      fechaCierre >= primerDiaSemanaPasada &&
                      fechaCierre <= ultimoDiaSemanaPasada &&
                      evento.StausTasks == 2
                    );
                  }
                );
              } else if (d.StausTasks == 3 && d.TypeStrategic === 2) {
                this.totalTaksOpenOnTimeEstrategico.push(d);
              } else if (d.StausTasks == 4 && d.TypeStrategic === 2) {
                this.totalTaksOpenOnLateEstrategico.push(d);

                this.taskOpenOnLateOnWeekEstrategico = resp.data.task.filter(
                  (evento) => {
                    // console.log("aaaa",primerDiaSemana, ultimoDiaSemana)
                    // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                    const fechaCierre = new Date(evento.LimiteDate);

                    if (
                      validateToday == 5 /*viernes*/ ||
                      validateToday == 6 /*Sabado*/
                    ) {
                      return (
                        fechaCierre >= primerDiaSemanaActual &&
                        fechaCierre <= ultimoDiaSemanaActual &&
                        evento.StausTasks == 4
                      );
                    }
                    return (
                      fechaCierre >= primerDiaSemanaPasada &&
                      fechaCierre <= ultimoDiaSemanaPasada &&
                      evento.StausTasks == 4
                    );
                  }
                );
              }
              this.percetangeWeekEstrategico =
                (this.totalTaksClosedOnTimeEstrategico.length /
                  (this.totalTaksClosedOnTimeEstrategico.length +
                    this.taskOpenOnLateOnWeekEstrategico.length +
                    this.taskCloseOnLateOnWeekEstrategico.length)) *
                100;
              this.percetangeWeekEstrategico = Math.round(
                this.percetangeWeekEstrategico
              );

              this.percetangeTotalEstrategico =
                (this.totalTaksClosedOnTimeEstrategico
                  .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                  (this.totalTaksOpenOnLateEstrategico.length +
                    this.totalTaksClosedOnTimeEstrategico.length +
                    this.totalTaksClosedOnLateEstrategico.length)) *
                100;
              this.percetangeTotalEstrategico = Math.round(
                this.percetangeTotalEstrategico
              );
            });

            // resp.data.task.forEach((d) => {
            //   this.TasktableData.push(d);
            //   if (d.StausTasks == 1) {
            //     this.totalTaksClosedOnTime.push(d);
            //   } else if (d.StausTasks == 2) {
            //     this.totalTaksClosedOnLate.push(d);
            //   } else if (d.StausTasks == 3) {
            //     this.totalTaksOpenOnTime.push(d);
            //   } else if (d.StausTasks == 4) {
            //     this.totalTaksOpenOnLate.push(d);
            //   }
            // });
          })
          .catch((err) => {
            console.error("Error en GetAutoMVsByOwner: ", err);
          });

        this.loading = false;
        this.openAutoMVView = true;
        this.isSupervisor = true;
      }
    },
    closeAutoMVView() {
      this.GetAutoMVsByMonth();
      this.openAutoMVView = false;
      this.isSupervisor = false;
      this.TasktableDataOperacional = [];
      this.totalTaksClosedOnTimeOperacional = [];
      this.totalTaksClosedOnLateOperacional = [];
      this.totalTaksOpenOnTimeOperacional = [];
      this.totalTaksOpenOnLateOperacional = [];
      this.taskCloseOnLateOnWeekOperacional = [];
      this.taskOpenOnLateOnWeekOperacional = [];
      this.TasktableDataEstrategico = [];
      this.totalTaksClosedOnTimeEstrategico = [];
      this.totalTaksClosedOnLateEstrategico = [];
      this.totalTaksOpenOnTimeEstrategico = [];
      this.totalTaksOpenOnLateEstrategico = [];
      this.taskCloseOnLateOnWeekEstrategico = [];
      this.taskOpenOnLateOnWeekEstrategico = [];
      this.percetangeWeekOperacional = 0;
      this.percetangeTotalOperacional = 0;
      this.percetangeWeekEstrategico = 0;
      this.percetangeTotalEstrategico = 0;
      this.TasktableData = [];
      // this.totalTaksClosedOnTime = [];
      // this.totalTaksClosedOnLate = [];
      // this.totalTaksOpenOnTime = [];
      // this.totalTaksOpenOnLate = [];
      // this.taskCloseOnLateOnWeek = [];
      // this.taskOpenOnLateOnWeek = [];
    },
    beforeClose() {
      this.$emit("close-autoMVDestails");
    },
    OnCloseDetailTotalConsumos() {
      this.showDrawerTotalConsumos = false;
      this.detailConsumosKey++;
    },
    OnCloseDetail() {
      this.showDrawer = false;
    }
  },
  watch: {
    showDrawerAutoMvReport(v) {
      if (v) {
        this.GetAutoMVsByMonth();
      }
    }
  }
};
</script>
<style lang="css" scoped>
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
